import { Popover } from "antd";
import React, { useState } from "react";
import CloseIcon from "../../../Common/Svgs/CloseIcon";
import ChevronIcon from "../../../Common/Svgs/ChevronIcon";

const Section = ({ title, content }) => (
  <div className="w-[50%]">
    <p className="px-6 py-3 font-normal text-10 bg-background text-center">
      {title}
    </p>

    {content.map((item) => (
      <p
        key={item}
        className="px-6 py-3 text-xs font-semibold text-center border-b-[0.5px] border-light-grey text-black"
      >
        {item}
      </p>
    ))}
  </div>
);

const BatteriesAssigned = ({ batteries }) => {
  const [open, setOpen] = useState(false);

  const getEnergyConsumed = () => {
    const data = batteries.map((b) => {
      const start = b.startEnergy || 0;
      const end = b?.endEnergy || 0;
      const consumed = start - end;
      return consumed ? `${consumed} kWh` : "--";
    });

    return data;
  };

  return (
    <Popover
      open={open}
      placement="top"
      trigger="click"
      arrow={false}
      onOpenChange={(state) => setOpen(state)}
      content={
        <div className="w-[460px] bg-background-white rounded-xl p-6 shadow-moreFilters">
          <div className="flex justify-between">
            <p className="text-base font-medium text-black font-poppins">
              Battery info
            </p>

            <button type="button" onClick={() => setOpen(false)}>
              <CloseIcon className="w-6 h-6 stroke-dark-gray" />
            </button>
          </div>

          <div className="flex mt-6 font-aileron text-dark-gray">
            <Section
              title="Battery ID"
              content={batteries.map((b) => b.registrationNo)}
            />

            <Section title="Energy Consumed" content={getEnergyConsumed()} />
          </div>
        </div>
      }
    >
      <div className="flex flex-col items-start gap-y-2 w-[137px]">
        <p className="font-aileron font-normal text-10 text-dark-gray capitalize">
          No. of batteries assigned
        </p>

        <button
          type="button"
          className="flex items-center gap-x-2"
          onClick={() => setOpen(true)}
        >
          <p className="font-aileron font-semibold text-xs text-black capitalize whitespace-nowrap">
            {batteries?.length ? `${batteries.length} batteries` : "--"}
          </p>

          {batteries?.length ? (
            <ChevronIcon className="w-4 h-4 stroke-dark-gray" />
          ) : null}
        </button>
      </div>
    </Popover>
  );
};

export default BatteriesAssigned;
